module.exports = __webpack_public_path__ + "img/terracenew_box05.a85853dc.jpg";